// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + ".ca93e3f50ad06785b5bdaf9694f63b1b.js";
};